import React from 'react'
import { useTranslation } from 'react-i18next'
import { Layout } from 'ui/layout/Layout'
import { AppBarCommon } from 'ui/partials/AppBar'
import { H2 } from 'ui/shorthands/Texts'
import CenteredContainer from 'ui/layout/CenteredContainer'

const LegacyBrowser: React.FC<{ type?: 'med' | 'personal' }> = ({
  type = 'med',
}) => {
  const { t } = useTranslation()
  return (
    <Layout header={<AppBarCommon type={type} />}>
      <CenteredContainer
        header={
          <H2>
            {t('errors.このブラウザではYaDoc Quickにアクセスできません。')}
          </H2>
        }
      >
        {t('errors.最新版のブラウザをご利用ください。')}
      </CenteredContainer>
    </Layout>
  )
}

export default LegacyBrowser
